import React, { FC } from 'react';
// eslint-disable-next-line import/no-cycle
import { useMyProfileQuery } from 'MyProfile/query/myProfile.query';

import { useActiveBusinessUnitsQuery } from 'Dictionary/query/dictionaryQuery';
import { mapToAutocompleteFieldItems } from 'Dictionary/model/BusinessUnit';
// eslint-disable-next-line import/no-cycle
import {
  FormikAutocompleteField,
  FormikAutocompleteFieldProps,
} from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';
import { AutocompleteFieldItem } from 'components/Field/AutocompleteField/AutocompleteField';

export interface ActiveBusinessUnitSelectFieldProps
  extends Omit<FormikAutocompleteFieldProps, 'options'> {
  defaultOptions?: AutocompleteFieldItem[];
  divisionID?: number;
}

export const allBusinessUnitField: AutocompleteFieldItem = {
  id: 0,
  name: 'All Divisions',
};

export const ActiveBusinessUnitSelectField: FC<
  ActiveBusinessUnitSelectFieldProps
> = ({
  defaultOptions = [],
  required = true,
  divisionID,
  ...otherProps
}) => {
    const { data = [], isLoading, refetch } = useActiveBusinessUnitsQuery(Number(divisionID ?? 0));
    const { data: userData } = useMyProfileQuery();
    const isAdmin = userData?.isAdmin;
    const localAdminRole = userData?.roles?.find((r) => r.type === 'LocalAdministrator');
    const isLocalAdmin = !!localAdminRole;
    const shouldDisableDivision = isAdmin ? true : !isLocalAdmin;
    const allowedDivisionCodes: string[] = !userData?.isAdmin && userData?.roles
      ? userData.roles
        .filter((r) => r.type === 'LocalAdministrator')
        .flatMap((r) => (r.details ?? []).map((d) => d.description1))
        .filter(Boolean)
        .map((x) => String(x))
      : [];
    const mappedItems = mapToAutocompleteFieldItems(data) ?? [];
    const filteredData = mappedItems.filter((d) => allowedDivisionCodes.includes(d.name ?? ''));
    let selectedOption: AutocompleteFieldItem[] = [];
    if (!shouldDisableDivision) {
      selectedOption = filteredData;
    } else {
      selectedOption = [...defaultOptions, ...mappedItems];
    }
    const businessUnitField: AutocompleteFieldItem = {
      id: 0,
      name: !shouldDisableDivision ? '' : 'All Divisions',
    };

    return (
      <FormikAutocompleteField
        {...otherProps}
        defaultValue={[businessUnitField]}
        options={selectedOption}
        loading={isLoading}
        onOpen={() => refetch()}
        required={required}
      />
    );
  };
